import { Link } from "wouter";
import { Home, ChevronRight } from "lucide-react";

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface PageBreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}

export function PageBreadcrumb({ items, className = "" }: PageBreadcrumbProps) {
  return (
    <nav
      className={`flex items-center gap-1 text-sm text-muted-foreground mb-6 ${className}`}
      aria-label="Breadcrumb"
      data-testid="breadcrumb-nav"
    >
      <Link href="/" className="flex items-center gap-1 hover:text-foreground transition-colors" data-testid="breadcrumb-home">
        <Home className="h-4 w-4" />
        <span>Home</span>
      </Link>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={index} className="flex items-center gap-1">
            <ChevronRight className="h-4 w-4 flex-shrink-0" />
            {!isLast && item.href ? (
              <Link
                href={item.href}
                className="hover:text-foreground transition-colors"
                data-testid={`breadcrumb-item-${index}`}
              >
                {item.label}
              </Link>
            ) : (
              <span
                className={isLast ? "text-foreground font-medium truncate max-w-[240px]" : ""}
                data-testid={`breadcrumb-item-${index}`}
              >
                {item.label}
              </span>
            )}
          </span>
        );
      })}
    </nav>
  );
}
